import { Create } from '@fund/api-modules';
import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';
// import TransformResponse from './decorator/TransformResponse';
import { Caches } from '../components/FundChart/model/decorator';

@CreateByUser({
  getBaseURL: (zone) => getApiHostWithoutEnv('tradeapilvs', zone),
  getUserParams: (userInfo) => {
    const {
      utoken, ctoken, uid, deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      Version: '6.5.5',
      version: '6.5.5',
      appVersion: '6.5.5',
      ServerVersion: '6.5.5',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})
@Create({
  baseURL: getApiHostWithoutEnv('tradeapilvs'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})
class EFTradeApi {
  // 获取基金经理信息
  GetHoldingFunds(uid) {
    return this.POST('/User/home/GetHoldingFunds', {
      UserId: uid,
      NeedRealFundCode: 'true',
    });
  }

  GetUserAllStatu(uid) {
    return this.POST('/User/home/GetUserAllStatu', {
      UserId: uid,
    });
  }

  // 获取新的摊薄成本单价
  @Caches(3 * 60 * 60 * 1000)
  GetFundsProductProfit(item) {
    return this.POST('/User/Asset/GetFundsProductProfit', {
      UserId: item.uid,
      FundCodes: item.FundCode,
      Span: '-2',
    });
  }
}
export default new EFTradeApi();
